class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const targetValue = new Date(this.dataset.targetDate).getTime();
    this.targetDate = Number.isNaN(targetValue) ? Date.now() : targetValue;
    this.sleepsEl = this.querySelector('[data-sleeps]');
    this.sleepsLabelEl = this.querySelector('[data-sleeps-label]');
    this.render();
  }

  render() {
    const diff = Math.max(0, this.targetDate - Date.now());
    const sleeps = Math.ceil(diff / 86400000);

    this.sleepsEl.textContent = String(sleeps);
    this.sleepsLabelEl.textContent = sleeps === 1 ? 'more sleep' : 'more sleeps';
  }
}

customElements.define('countdown-timer', CountdownTimer);
